<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_18"></a><a id="pg18lev1"></a><img alt="Cream of tomato soup with crunchy lemon chickpeas" src="images/f0018-01.jpg"/></h2>
<p class="recipe_hdnote">Anyone who has ever cooked and eaten on a budget in the United Kingdom will be familiar with some of Britain’s perennial foodstuffs: canned soup and tomatoey baked beans. They were the standby meals of choice back in my university days, and there is nothing quite like a cream of tomato soup to brighten up a winter night.</p>
<p class="recipe_hdnote">I love these lemony chickpeas (I always have a can of chickpeas on hand in the cupboard); they’re my version of croutons. I like to sprinkle them on top of soups, but they are equally delicious as a stand-in for nuts—a homemade bar snack.</p>
<div class="wrap">
<p class="image"><a id="page_19"></a><img alt="image" class="vertical" src="images/f0019-01.jpg"/></p>
</div>
<p class="yield">Serves 4 as a starter</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 15 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 35 to 45 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="ingred_sublist">one 14-oz can chickpeas, drained and rinsed</p>
<p class="ingred_sublist">1 unwaxed lemon, sliced</p>
<p class="ingred_sublist">4 cloves of garlic, unpeeled</p>
<p class="ingred_sublist">1 tbsp canola or other vegetable oil</p>
<p class="ingred_sublist">sea salt</p>
<p class="ingred_sublist">one 28-oz can good-quality cherry tomatoes</p>
<p class="ingred_sublist">1 cup vegetable stock or water</p>
<p class="ingred_sublist">1 tsp sugar</p>
<p class="ingred_sublist">1 tbsp red wine vinegar</p>
<p class="ingred_sublist">freshly ground pepper</p>
<p class="ingred_sublist"><sup>3</sup>/<sub>4</sub> cup heavy cream</p>
<p class="method_txt">Preheat the oven to 350°F.</p>
<p class="method_txt">Combine the chickpeas, lemon slices, garlic, and oil in a small bowl and toss to coat. Place the chickpeas on a rimmed baking sheet. Sprinkle with salt and roast for 30 to 40 minutes, or until golden and crunchy.</p>
<p class="method_txt">Meanwhile, put the tomatoes and stock in a medium saucepan and bring to a simmer. Remove the roasted garlic from the baking sheet and squeeze the garlic from its papery husks, then add to the saucepan and simmer for 5 minutes. Add the sugar and vinegar and continue simmering for 1 minute. Taste for salt and pepper and stir in half the cream, then remove from the heat and use an immersion blender to blend until smooth.</p>
<p class="method_txt">Ladle the soup into bowls and garnish with the crunchy chickpeas, a slice of roasted lemon, and a drizzle of the remaining cream.</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/f0018-02.jpg"/></p>
</div>
<p class="sidebar2_hd">Tip</p>
<p class="sidebar1_txt"><em>Don’t boil the soup with the cream in it, as it will curdle</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09-chapter03.vue?248cec1e